import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import 'chartjs-plugin-datalabels'
import {
  GenderChart,
  EmployeeTypeChart,
  NewEmployeeChart,
} from '../../../components/report/charts/headcount'
import { FONTS, COLORS } from '../../../constants'

class HeadcountYear extends React.PureComponent {
  render() {
    return (
      <Wrapper>
        <ChildWrapper width={ 50 }>
          <Chart>
            <Header>{ 'Headcount report by gender and period (Permanent Employee)' }</Header>
            <GenderChart
              idchart={ `genderYears` }
              data={ get(this.props, 'genderYears') }
            />
          </Chart>
        </ChildWrapper>
        <ChildWrapper width={ 50 }>
          <Chart>
            <Header>{ 'Headcount report by employees type and period' }</Header>
            <EmployeeTypeChart
              idchart={ 'empTypeYears' }
              data={ get(this.props, 'empTypeYears') }
            />
          </Chart>
        </ChildWrapper>
        <ChildWrapper width={ 50 }>
          <Chart>
            <Header>{ 'Headcount of New employees and resigned by period (Permanent Employee)' }</Header>
            <NewEmployeeChart
              idchart={ 'empMovements' }
              data={ get(this.props, 'empMovements') }
            />
          </Chart>
        </ChildWrapper>
      </Wrapper>
    )
  }
}

export default HeadcountYear

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const ChildWrapper = styled.div`
  width: 50%;
`
const Header = styled.div`
  height: 40px;
  width: 100%;
  background: ${COLORS.TABLE_HEADER_COLOR};
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  display: flex;
  padding-left: 10px;
  align-items: center;
`
const Chart = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/report/headcount/report-year.js